import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=0d84f9ca&scoped=true"
import script from "./companyProfile.vue?vue&type=script&lang=js"
export * from "./companyProfile.vue?vue&type=script&lang=js"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=0d84f9ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84f9ca",
  null
  
)

export default component.exports